import React from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

import { ContentListItem } from 'components/ContentBox/ContentListItem';
import { ContentBox } from 'components/ContentBox';

type InputProps = {
  avatar?: string;
  name: string;
  role: string;
  className?: string;
};

export const UserDashboard = ({
  avatar,
  name,
  role,
  className,
}: InputProps) => {
  return (
    <ContentBox className={clsx(styles.root, className)}>
      <ContentListItem
        icon={
          avatar ? (
            <img className={styles.avatar} src={avatar} alt={name} />
          ) : (
            <div className={styles.defaultLogo}>{name.slice(0, 1)}</div>
          )
        }
        title={name}
        subtitle={<div className={styles.role}>{role}</div>}
      />
    </ContentBox>
  );
};
